import {
  config as countryConfigs,
  getCountryConfig,
} from '../config/country-config';
import { FormSelectOption } from '../forms/forms.models';
import { AbstractControl } from '@angular/forms';

export const nameFieldRegex =
  "(^$|^[a-zA-Z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF]+[a-zA-Z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF-' ]+$)";

export const fncValidateNoSpaces = (
  control: AbstractControl
): { [key: string]: any } | null => {
  if (control.value && control.value.trim().length === 0) {
    return { noSpaces: true };
  }
  return null;
};

export const basicInfoData: RegistrationConfig = {
  pageHeader: 'Now, we just need a little more information about you.',
  subHeader:
    'Please make sure the name and date of birth match the ID you present in store.',
  personalInfoHeader: 'Personal Information',
  addressInfoHeader: 'Address and Phone Number',
  addressFieldsTemplate: [
    'address',
    'addressLine2',
    'city',
    'country',
    'state',
    'postalCode',
  ],
  personalFieldsTemplate: [
    'firstName',
    'middleName',
    'lastName',
    'secondLastName',
    'dateOfBirth',
    'mobileNumber',
    'mobileCountry',
  ],
  fields: {
    personalInfoFields: [
      {
        controlType: 'input',
        fieldMaxLength: 20,
        fieldMinLength: 1,
        // fieldLabel: "Legal First Name",
        name: 'firstName',
        pattern:
          "(^$|^[a-zA-Z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF]+[a-zA-Z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF-' ]+$)",
        required: true,
      },
      {
        controlType: 'input',
        fieldMaxLength: 30,
        fieldMinLength: 1,
        // fieldLabel: "Legal Last Name",
        name: 'lastName',
        pattern:
          "(^$|^[a-zA-Z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF]+[a-zA-Z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF-' ]+$)",
        required: true,
      },
      {
        controlType: 'input',
        fieldMaxLength: 20,
        fieldMinLength: 0,
        fieldLabel: 'Middle Name (If Listed On Id)',
        name: 'middleName',
        pattern:
          "(^$|^[a-zA-Z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF]+[a-zA-Z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF-' ]+$)",
        required: false,
      },
      {
        controlType: 'input',
        fieldMaxLength: 30,
        fieldMinLength: 0,
        fieldLabel: 'Second Last Name (If Listed On Id)',
        name: 'secondLastName',
        pattern:
          "(^$|^[a-zA-Z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF]+[a-zA-Z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF-' ]+$)",
        required: false,
      },
      {
        controlType: 'date',
        fieldLabel: 'Date Of Birth',
        name: 'dateOfBirth',
        dateLong: 'MMM D, YYYY',
        dateShort: 'MM/DD/YYYY',
        pattern: 'MM/dd/yyyy',
        required: true,
      },
      {
        controlType: 'input',
        copyPasteForbidden: false,
        dataType: 'PHONE',
        name: 'mobileNumber',
        fieldLabel: 'Mobile Number',
        required: true,
      },
      {
        controlType: 'select',
        copyPasteForbidden: false,
        dataType: 'STRING',
        name: 'mobileCountry',
        fieldLabel: 'Phone Country',
        fieldMaxLength: 3,
        fieldMinLength: 3,
        required: true,
      },
    ],
  },
};

export const registrationData: RegistrationConfig = {
  pageHeader: 'Now, we just need a little more information about you.',
  subHeader:
    'Please make sure the name and date of birth match the ID you present in store.',
  personalInfoHeader: 'Personal Information',
  addressInfoHeader: 'Address and Phone Number',
  addressFieldsTemplate: [
    'address',
    'addressLine2',
    'city',
    'country',
    'state',
    'postalCode',
  ],
  personalFieldsTemplate: [
    'firstName',
    'middleName',
    'lastName',
    'secondLastName',
    'dateOfBirth',
    'mobileNumber',
    'mobileCountry',
  ],
  fields: {
    personalInfoFields: [
      {
        controlType: 'input',
        fieldMaxLength: 20,
        fieldMinLength: 1,
        // fieldLabel: "Legal First Name",
        name: 'firstName',
        pattern:
          "(^$|^[a-zA-Z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF]+[a-zA-Z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF-' ]+$)",
        required: true,
      },
      {
        controlType: 'input',
        fieldMaxLength: 30,
        fieldMinLength: 1,
        // fieldLabel: "Legal Last Name",
        name: 'lastName',
        pattern:
          "(^$|^[a-zA-Z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF]+[a-zA-Z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF-' ]+$)",
        required: true,
      },
      {
        controlType: 'input',
        fieldMaxLength: 20,
        fieldMinLength: 0,
        fieldLabel: 'Middle Name (If Listed On Id)',
        name: 'middleName',
        pattern:
          "(^$|^[a-zA-Z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF]+[a-zA-Z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF-' ]+$)",
        required: false,
      },
      {
        controlType: 'input',
        fieldMaxLength: 30,
        fieldMinLength: 0,
        fieldLabel: 'Second Last Name (If Listed On Id)',
        name: 'secondLastName',
        pattern:
          "(^$|^[a-zA-Z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF]+[a-zA-Z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF-' ]+$)",
        required: false,
      },
      {
        controlType: 'date',
        fieldLabel: 'Date Of Birth',
        name: 'dateOfBirth',
        dateLong: 'MMM D, YYYY',
        dateShort: 'MM/DD/YYYY',
        pattern: 'MM/dd/yyyy',
        required: true,
      },
      {
        controlType: 'input',
        copyPasteForbidden: false,
        dataType: 'PHONE',
        name: 'mobileNumber',
        fieldLabel: 'Mobile Number',
        required: true,
      },
      {
        controlType: 'select',
        copyPasteForbidden: false,
        dataType: 'STRING',
        name: 'mobileCountry',
        fieldLabel: 'Phone Country',
        fieldMaxLength: 3,
        fieldMinLength: 3,
        required: true,
      },
    ],
    addressInfoFields: [
      {
        controlType: 'input_large',
        fieldMaxLength: 30,
        fieldMinLength: 5,
        fieldLabel: 'Address',
        name: 'address',
        pattern:
          '^$|^(?!.*([#\\-!@$%^&*(),./\'"])\\1)[a-zA-Z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF0-9.\\-/\'",#() ]+$',
        required: true,
      },
      {
        controlType: 'input_large',
        fieldMaxLength: 30,
        fieldMinLength: 0,
        fieldLabel: 'Address Line 2 (Optional)',
        name: 'addressLine2',
        pattern:
          '^$|^(?!.*([#\\-!@$%^&*(),./\'"])\\1)[a-zA-Z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF0-9.\\-/\'",#() ]+$',
        required: false,
      },
      {
        controlType: 'input',
        fieldMaxLength: 40,
        fieldMinLength: 1,
        fieldLabel: 'City',
        name: 'city',
        pattern: '^([a-zA-Z \\u00C0-\\u017F\\#\\/\\.\\"\\\'\\(\\)\\-])*$',
        required: true,
      },
      {
        controlType: 'select',
        fieldMaxLength: 40,
        fieldMinLength: 1,
        name: 'country',
        disabled: false,
        required: true,
      },
      // TODO -- {#TECHDEBT} -- hard-coding for US for initial release
      // states should account for passed country when we have more
      {
        controlType: 'select',
        fieldMaxLength: 40,
        fieldMinLength: 1,
        fieldLabel: 'State',
        name: 'state',
        disabled: false,
        required: true,
        // defaults to US
        options: getCountryConfig().states!.map((state) => ({
          label: state.name,
          value: state.code,
        })),
      },
      {
        controlType: 'input',
        fieldMaxLength: 10,
        fieldMinLength: 2,
        fieldLabel: 'Zip Code',
        name: 'postalCode',
        // pattern: "^[a-zA-Z0-9-]*$", // Validation is handled by the validatePostcode function in registration.component.ts
        required: true,
      },
    ],
  },
};

export const dateRegex =
  /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;

export interface RegistrationConfig {
  pageHeader?: string;
  subHeader?: string;
  personalInfoHeader?: string;
  addressInfoHeader?: string;
  addressFieldsTemplate?: string[];
  personalFieldsTemplate?: string[];
  fields: FieldsConfig;
}

export interface BasicInfoConfig {
  pageHeader?: string;
  subHeader?: string;
  personalInfoHeader?: string;
  fieldsTemplate?: string[];
  fields: FieldsConfig;
}

export interface FieldsConfig {
  personalInfoFields?: FieldConfig[];
  addressInfoFields?: FieldConfig[];
}
export interface FieldConfig {
  controlType?: string;
  inputType?: string;
  dataType?: string;
  fieldLabel?: string;
  fieldLabelKey?: string;
  fieldMaxLength?: number;
  fieldMinLength?: number;
  dateLong?: string;
  dateShort?: string;
  options?: FormSelectOption[];
  copyPasteForbidden?: boolean;
  name: string;
  pattern?: string;
  required?: boolean;
  disabled?: boolean;
}

export enum ErrorMsgs {
  required = 'is required',
  pattern = 'has invalid characters',
  maxLength = 'too long',
  minLength = 'too short',
  invalid = 'is invalid',
  invalidOption = 'Option not found!',
  max = 'You must be at least 18 years old',
  min = 'Date must be less than 100 years',
  minOrMaxLengthPostalCodeMsg = 'Please enter a valid postal code',
}

export enum FormControlTypes {
  INPUT = 'input',
  INPUT_LARGE = 'input_large',
  SELECT = 'select',
  DATE = 'date',
}

export enum FieldNames {
  state = 'state',
  mobileNumber = 'mobileNumber',
  mobileCountry = 'mobileCountry',
  dob = 'dateOfBirth',
  line1 = 'line1',
  line2 = 'line2',
  countrySubdivisionCode = 'countrySubdivisionCode',
  countryCode = 'countryCode',
  address = 'address',
  addressLine2 = 'addressLine2',
  country = 'country',
  city = 'city',
  postalCode = 'postalCode',
}
export enum postalCodeTranslatedLang {
  'Postal Code',
  'Código postal',
  'Поштовий індекс',
}

export interface MobileNumber {
  number: string;
  countryDialCode: string;
  country?: string;
}
